import type { CompanyConfiguration } from 'shared/hooks/use-load-company-configuration';

import type { CreateAutomationVariables } from '../../../api';

import type { AutomationActionType } from './types';

export const MODEL_TO_ACTION_TYPES: Record<
  CreateAutomationVariables['targetModel'],
  Record<CompanyConfiguration['package']['automation'], Array<AutomationActionType>>
> = {
  debtor: {
    full_automations: [
      'CopyValueToField',
      'CopyFieldToField',
      'AssignAccountManager',
      'AssignRecoveryPlan',
      'Pause',
      'Unpause',
    ],
    legacy_automations: ['AssignAccountManager', 'AssignRecoveryPlan'],
    no_automations: [],
  },
  invoice: {
    full_automations: [
      'CopyValueToField',
      'CopyFieldToField',
      'AssignAccountManager',
      'AssignRecoveryPlan',
    ],
    legacy_automations: ['AssignAccountManager', 'AssignRecoveryPlan'],
    no_automations: [],
  },
};
